import { Button, Spin } from "antd";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { api, endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import WaterTariffTable from "./WaterTariffTable";

export default function WaterTariff() {
  const [isLoading, setIsLoading] = useState(false);
  const [waterTariff, setWaterTariff] = useState([]);
  const [mode, setMode] = useState(false);
  const [limit] = useState(100);
  const [page] = useState(1);

  const getWaterTariff = async () => {
    setIsLoading(true);
    try {
      let { results } = await api.get(endpoint.get_water_tariff, {
        params: { limit, page, sortBy: "position", orderBy: "ASC" },
      });

      const unique = Array.from(new Map((results || []).map((item) => [item.name, item])).values());
      setWaterTariff(unique);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onUpdateTariff = async () => {
    setIsLoading(true);
    try {
      await api.put(endpoint.update_water_tariff, {
        data: waterTariff,
      });
      await getWaterTariff();

      Swal.fire({
        title: "Done!",
        text: "Water Tariff Updated Successfully",
        icon: "success",
        timer: 2000,
        confirmButtonText: "OK",
      });
      setMode(false);
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: "Failed to update water tariff",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getWaterTariff();
  }, [limit, page]);

  useEffect(() => {
    document.title = `${appConfig.name} - Manage Water Tariff`;
  }, []);

  return (
    <div className="card p-3 m-md-3">
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <label className="az-content-label">Settings</label>
          <span className="d-block py-2">Manage Water Tariff</span>
        </div>
      </div>
      <hr className="mt-0" />
      <div className="row mt-4">
        <div className="col-md-12">
          <Spin spinning={isLoading}>
            <WaterTariffTable
              waterTariff={waterTariff}
              setWaterTariff={setWaterTariff}
              mode={!mode}
            />
          </Spin>
          <div className="d-flex justify-content-end mt-4">
            {mode ? (
              <>
                <Button type="primary" className="me-2" onClick={onUpdateTariff}>
                  Update Tariff
                </Button>
                <Button
                  htmlType="button"
                  type="primary"
                  className="bg-secondary"
                  onClick={() => {
                    getWaterTariff();
                    setMode(false);
                  }}
                >
                  Cancel
                </Button>
              </>
            ) : (
              <Button
                className="me-2"
                type="primary"
                onClick={() => {
                  Swal.fire({
                    title: "Are you sure?",
                    text: "Do you want to make changes to the water tariff?",
                    dangerMode: true,
                    showCancelButton: true,
                    confirmButtonText: "Confirm",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      setMode(true);
                    }
                  });
                }}
              >
                Edit Tariff
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
